import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white px-4 pt-16 pb-24 sm:px-6 sm:pt-24 lg:px-8 lg:py-32 shadow-2xl" }
const _hoisted_2 = { class: "max-w-3xl mx-auto" }
const _hoisted_3 = { class: "max-w-xl" }
const _hoisted_4 = { class: "mt-2 text-2xl font-extrabold tracking-tight sm:text-3xl" }
const _hoisted_5 = { class: "mt-2 text-base text-gray-500" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.canEdit)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: `/posts/${_ctx.post.id}/edit`,
          class: "block w-16 px-4 py-1 mt-24 mb-2 ml-2 text-white rounded-md bg-gradient-to-r from-green-500 to-blue-500 whitespace-nowrap",
          "data-test": "can-edit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Edit ")
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.post.title), 1),
          _createElementVNode("p", _hoisted_5, "Post id : " + _toDisplayString(_ctx.post.id), 1),
          _createElementVNode("div", {
            innerHTML: _ctx.post.html
          }, null, 8, _hoisted_6)
        ])
      ])
    ])
  ], 64))
}